import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface MailIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const MailIcon = ({ className, ...props }: MailIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 9L12 12.5L17 9"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M2 17V7C2 5.89543 2.89543 5 4 5H20C21.1046 5 22 5.89543 22 7V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export default MailIcon;
